// @flow
import React from 'react'
import styled, { css } from 'styled-components'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { getStyleUnit } from 'components/styles/helpers'

const PartsContainer = styled.div`
  display: block;
  ${({ spacing }) =>
    spacing &&
    css`
      margin: -${spacing}px -${spacing / 2}px 0;
    `}
  ${({ positionType }) =>
    positionType &&
    css`
      float: ${positionType};
    `}
  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `}
`

const Container = styled.div`
  display: inline-block;
  vertical-align: middle;
  ${({ spacing }) =>
    spacing &&
    css`
      padding: ${spacing}px ${spacing / 2}px 0;
    `}
  ${({ partsWidth, isFixed }) =>
    partsWidth &&
    css`
      width: ${isFixed ? getStyleUnit(partsWidth) : '100%'};
      max-width: ${getStyleUnit(partsWidth)};
      ${({ spacing }) =>
        spacing &&
        css`
          max-width: ${partsWidth +
            spacing +
            (typeof partsWidth === 'number' ? 'px' : '')};
        `};
    `}
  ${({ partsWidthSp, isFixed }) =>
    partsWidthSp &&
    css`
      ${mediaMax.phone`
      width: ${isFixed ? getStyleUnit(partsWidthSp) : '100%'}
      max-width: ${getStyleUnit(partsWidthSp)};
      ${({ spacing }) =>
        spacing &&
        css`
          max-width: ${partsWidthSp +
            spacing +
            (typeof partsWidthSp === 'number' ? 'px' : '')};
        `}
    `};
    `}
  ${({ verticalAlign }) =>
    verticalAlign &&
    css`
      vertical-align: ${getStyleUnit(verticalAlign)};
    `}
`

function getItemAtIndex(spacing, index) {
  return Array.isArray(spacing) ? spacing[index] : spacing
}

type PropTypes = {
  width?: any,
  isFixed?: boolean,
  verticalAlign?: any,
  textAlign?: any,
  spacing: number,
  children: any,
  positionType: string,
}

export default (props: PropTypes) => {
  return (
    <PartsContainer
      spacing={props.spacing}
      positionType={props.positionType}
      textAlign={props.textAlign}
    >
      {Array.isArray(props.children) ? (
        props.children.map((child, index) => (
          <Container
            partsWidth={getItemAtIndex(props.width, index)}
            partsWidthSp={getItemAtIndex(props.widthSp, index)}
            verticalAlign={getItemAtIndex(props.verticalAlign, index)}
            spacing={props.spacing}
            isFixed={props.isFixed}
            key={index}
          >
            {child}
          </Container>
        ))
      ) : (
        <Container
          partsWidth={props.width}
          partsWidthSp={props.widthSp}
          verticalAlign={props.verticalAlign}
          spacing={props.spacing}
          isFixed={props.isFixed}
        >
          {props.children}
        </Container>
      )}
    </PartsContainer>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/PartsContainer/index.jsx